import { Navigate } from 'react-router-dom';
import { isTenantDomain } from '@/utils/tenantDomain';

interface TenantOnlyRouteProps {
  children: React.ReactNode;
}

/**
 * Route wrapper that ensures the route is only accessible on tenant subdomains.
 * Redirects to admin portal login if accessed on public domain.
 */
const TenantOnlyRoute: React.FC<TenantOnlyRouteProps> = ({ children }) => {
  // If not on a tenant subdomain, redirect to admin login
  if (!isTenantDomain()) {
    return <Navigate to="/admin/login" replace />;
  }

  // On tenant subdomain - render the route
  return <>{children}</>;
};

export default TenantOnlyRoute;
